import Glide from "@glidejs/glide";

export default class Slider {
  constructor(element) {
    if (!element) return;
    this.sliders = [];
    this.element = element;

    // in the Neos backend the element information is rendered in a appended script tag
    // since this script is executed after it's evaluation, we can safely remove it
    // to make the slider work properly
    const isNeosBackend = document.body.classList.contains('neos-backend');
    if (isNeosBackend) {
      Array.from(document.querySelectorAll('script[data-neos-nodedata]')).forEach((script) => script.remove())
    }

    let bulletCount = element.querySelectorAll('.glide__slide').length;
    let bulletWrapper = element.parentElement.querySelector('.glide__bullets');

    if (bulletCount > 1) {
      if (bulletWrapper) {
        for (let index = 0; index < bulletCount; index++) {
          const button = document.createElement('button');
          button.className = 'glide__bullet';
          button.setAttribute("data-glide-dir", '=' + index);

          bulletWrapper.appendChild(button)
        }
      }
    } else {
      if (bulletWrapper) {
        bulletWrapper.remove();
      }
    }

    let type = '';
    if (element.parentElement.parentElement.classList.contains('hero-slider')) {
      type = 'hero';
    }
    if (element.parentElement.parentElement.classList.contains('post-slider')) {
      type = 'post';
    }
    if (element.parentElement.parentElement.classList.contains('product-slider')) {
      type = 'product';
    }
    if (element.parentElement.parentElement.classList.contains('category-slider')) {
      type = 'category';
    }

    let options = {};
    switch (type) {
      case 'hero':
        options = {
          peek: 0,
          gap: 0,
          arrows: false,
          rewind: false,
          type: 'carousel',
          startAt: 0,
          perView: 1,
          autoplay: isNeosBackend ? false : 6000,
        };
        break;

      case 'post':
        options = {
          peek: {before: 0, after: 135},
          gap: 15,
          arrows: false,
          rewind: false,
          type: 'slider',
          startAt: 0,
          focusAt: 0,
          perView: 2,
          bound: true,
          animationTimingFunc: 'ease-in-out',
          animationDuration: 800,
          breakpoints: {
            767: {
              perView: 1,
              gap: 20,
              peek: {before: 0, after: 60},
            }
          }
        };
        break;

      case 'category':
        options = {
          peek: 400,
          gap: 15,
          arrows: false,
          rewind: false,
          type: 'carousel',
          startAt: 0,
          focusAt: 0,
          perView: 2,
          animationTimingFunc: 'ease-in-out',
          animationDuration: 800,
          breakpoints: {
            767: {
              perView: 1,
              gap: 20,
              peek: {before: 0, after: 95},
            },
            991: {
              peek: {before: 200, after: 200},
            },
            1279: {
              peek: {before: 200, after: 200},
            },
            1439: {
              peek: {before: 175, after: 175},
            },
            1599: {
              peek: {before: 250, after: 250},
            }
          }
        };
        break;

      case 'product':
        options = {
          peek: {before: 0, after: 135},
          gap: 20,
          arrows: false,
          rewind: false,
          type: 'slider',
          startAt: 0,
          focusAt: 0,
          perView: 4,
          animationTimingFunc: 'ease-in-out',
          animationDuration: 800,
          breakpoints: {
            767: {
              perView: 1,
              gap: 20,
            },
            991: {
              perView: 2,
              peek: {before: 0, after: 75},
            },
            1279: {
              perView: 3,
              peek: {before: 0, after: 135},
            }
          }
        };
        break;
    }

    let slider = new Glide(element, options);
    if (type === 'hero') {
      slider
        .on(['run.after', 'swipe'], () => {
          let playerElement = element.querySelector(`.glide__slide--active .player`);

          if (playerElement) {
            let player = window.players.find(el => el.id === playerElement.dataset.id).player;
            player.mute();
            player.seekTo(0);
            player.playVideo();
          }
        })
        .on('move', () => {
          let playerElement = element.querySelector(`.glide__slide--active .player`);

          if (playerElement) {
            let player = window.players.find(el => el.id === playerElement.dataset.id).player;
            player.pauseVideo();
          }
        })
        .on('run.end', () => {
          let playerElement = element.querySelector(`.glide__slide--active .player`);

          if (!playerElement) {
            if (slider.index + 1 === element.querySelectorAll(`.glide__slide`).length) {
              slider.go('=0');
            }
          }
        })
        .on(['swipe.start'], () => false)
    }

    if (type === 'product') {
      slider
        .on('run.after', () => {
          let viewed = window.innerWidth < 768 ? 0 : window.innerWidth < 992 ? 1 : window.innerWidth < 1280 ? 2 : options.perView - 1;
          console.log(viewed)
          console.log(slider.index, element.querySelectorAll(`.glide__slide`).length - options.perView);
          if (slider.index >= element.querySelectorAll(`.glide__slide`).length - viewed) {
            setTimeout(()=>{
              slider.go('=' + (slider.index - 1));
            }, 1)
          }
        })
    }

    // disable left arrow when first slide is visible and right arrow when last slide is visible
    let ArrowDisable = function (Glide, Components, Events) {
      return {
        mount() {
          // Only in effect when rewinding is disabled
          if (Glide.settings.rewind) {
            return
          }

          if (Glide.selector.parentElement.parentElement.classList.contains('category-slider')) return;

          Glide.on(['mount.after', 'run'], () => {
            // Filter out arrows_control
            for (let controlItem of Components.Controls.items) {
              if (controlItem.className !== 'glide__arrows') {
                continue
              }

              // Set left arrow state
              let left = controlItem.querySelector('.glide__arrow--left');
              if (left) {
                if (Glide.index === 0) {
                  left.setAttribute('disabled', '') // Disable on first slide
                } else {
                  left.removeAttribute('disabled') // Enable on other slides
                }
              }

              // Set right arrow state
              let right = controlItem.querySelector('.glide__arrow--right')
              if (right) {
                if (Glide.index >= Components.Sizes.length - Glide.settings.perView) {
                  right.setAttribute('disabled', '') // Disable on last slide
                } else {
                  right.removeAttribute('disabled') // Disable on other slides
                }
              }
            }
          })
        }
      }
    };

    if (element.parentElement.classList.contains('has-arrows')) {
      this.slider = slider.mount({ArrowDisable});
    } else {
      this.slider = slider.mount();
    }

    return {type: type, slider: this.slider};
  }

  get() {
    return this.slider;
  }
}

